type EventName = 'login' | 'logout' | 'expandMemberTraining' | 'reloadSelectedMember' | 'resetExerciseConfig' | 'setExerciseConfigRepetitions' | 'reloadNotes'
  | 'applyMeasurementsChange' | 'reloadBodyMeasurements' | 'reloadCheckups' | 'reloadHealthGoal' | 'reloadWorkouts' | 'printOneExercise' | 'reloadSupportTickets'

class EventBus {

  private handlers: { [key: string]: Array<Function> } = {}

  on (eventName: EventName, handler: Function) {
    this.handlers[eventName] = (this.handlers[eventName] || []).concat([handler])
  }

  off (eventName: EventName, handler?: Function) {
    if (handler) {
      this.handlers[eventName] = (this.handlers[eventName] || []).filter(
        (x) => x !== handler
      )
    } else {
      this.handlers[eventName] = []
    }
  }

  trigger (eventName: EventName, ...args) {
    (this.handlers[eventName] || []).forEach((fun) => fun.apply(null, args))
    this.sendToElectron(eventName, args)
  }

  /* istanbul ignore next */
  private sendToElectron (eventName, args) {
    let global = (window || {}) as any
    if (global.process && global.process.type === 'renderer') {
      const electron = global.require('electron')
      electron.ipcRenderer.sendSync.apply(null, [eventName].concat(args))
    }
  }
}

export default new EventBus()
